import React, { useEffect, useState } from 'react';
import { headerApi } from 'services/camMirrorService';

export function useHeaderV2Flag(
  studentId: string | number | null | undefined,
  options?: { waitForId?: boolean },
) {
  const waitForId = options?.waitForId ?? false;
  const requestId =
    studentId == null || studentId === '' || studentId === ':id' ? null : String(studentId);
  const [state, setState] = useState<{ id: string | null; enabled: boolean }>({
    id: null,
    enabled: false,
  });

  useEffect(() => {
    if (!requestId) return;
    let cancelled = false;
    headerApi
      .isEnabled(requestId)
      .then((next) => {
        if (!cancelled) setState({ id: requestId, enabled: Boolean(next) });
      })
      .catch(() => {
        if (!cancelled) setState({ id: requestId, enabled: false });
      });
    return () => {
      cancelled = true;
    };
  }, [requestId]);

  const settled = state.id === requestId;
  return {
    enabled: settled ? state.enabled : false,
    ready: requestId ? settled : !waitForId,
  };
}

const HeaderV2Gate: React.FC<{ studentId: string | number | null | undefined; children: React.ReactNode }> = ({
  studentId,
  children,
}) => {
  const { enabled } = useHeaderV2Flag(studentId);
  if (!enabled) return null;
  return <>{children}</>;
};

export default HeaderV2Gate;
